import authRoles from 'app/auth/authRoles';
import Orders from './Orders';

const OrdersConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          generalMenu: true,
          personalMenu: true,
        },
      },
    },
  },
  auth: authRoles.user,
  routes: [
    {
      path: '/orders/:id',
      component: Orders,
    },
  ],
};

export default OrdersConfig;
